import { Component } from '@angular/core';
import { SecondaryNavComponent } from 'src/app/global-composants/secondary-nav/secondary-nav.component';
import { Ope } from 'src/app/models/Ope';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { DocServices } from 'src/app/services/docs/docs.services';
import { OptionServices } from 'src/app/services/options/option.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { ProgrammePresentationComponent } from './programme-presentation/programme-presentation.component';
import { ProgrammeOptionsComponent } from './programme-options/programme-options.component';
import { ListeBiensComponent } from './liste-biens/liste-biens.component';
import { GalerieComponent } from './galerie/galerie.component';
import { DocListComponent } from './doc-list/doc-list.component';

@Component({
  selector: 'app-page-programme',
  templateUrl: './page-programme.component.html',
  imports: [SecondaryNavComponent,ProgrammePresentationComponent, ProgrammeOptionsComponent,ListeBiensComponent,GalerieComponent,DocListComponent],
  styleUrls: ['./page-programme.component.scss']
})
export class PageProgrammeComponent {
  numope!: number;
  pathListImages!: vignetteOpe[];
  programme!: Ope | null;

  constructor(
    public share: shareOpeSevices,
    private readonly docsndVigneteService: DocServices,
    private readonly optionService: OptionServices
  ) { }

  ngOnInit() {
    this.populate();
  }

  populateOption(programmeseled: Ope) {
    this.optionService.getOptionByProgramme(programmeseled.numOpeExt).subscribe((data) => {
      this.share.sendOptions(data);
    });
  }

  populate() {
    //const storedProgramme = window.localStorage.getItem('programme');
    const storedProgramme = null;
    if (storedProgramme) {
      this.programme = JSON.parse(storedProgramme as string);
      if (this.programme) {
        this.numope = this.programme.numOpe;
        this.populateOption(this.programme);
        const opes: Ope[] = [this.programme];
        this.share.sendOpes(opes);
      }
    } else {
      this.share.datasOpe$.subscribe((res) => {
        this.programme = res;
        this.numope = this.programme.numOpe;
        this.populateOption(this.programme);
        const opes: Ope[] = [this.programme];
        this.share.sendOpes(opes);
      });
    }

    this.docsndVigneteService.getVignetteBynumOpe(this.numope).subscribe((res) => {
      this.share.fetchVignettesOffrOpe(res);
    });
  }
}